module.exports = __webpack_public_path__ + "img/product_yzm1.ab6e7e99.png";